<template>
  <div class="wind-template">
      <div class="card z-depth-0 custom-yellow grey-text text-darken-4">
        <div class="card-content">
          <div class="step-title">
            Expected Impact Level
          </div>
          <p>
            The expected impact level to your home from a two-week cut in WASCO water supply is determined by comparing your household's two-week water demand for essential and non-essential uses to your water storage capacity.
          </p>
          <p>
            Click the <b>"confirm"</b> option if you accept the estimated impact. 
            If you disagree with the estimation, use the <a href="#" helper-id="C001">Expected Impact Level Chart</a> to select your expected impact level from a 2-week cut in WASCO water supply. Apply your best judgement using information from the assessment, additional knowledge of your home and past experiences to select the most likely expected impact level for your home. Write a brief justification for your selection in the space provided.
          </p>
        </div>
      </div>
  </div>
</template>
<script>

export default {
  name: 'waterSurveyFinal',
  mounted (){
    this.$_setupHelpers()
  },
  methods:{
    $_openModal() {
      this.$emit('openModal', true)
    },
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault()
            const helperId = helperEl.getAttribute("helper-id")
            const styles = helperEl.getAttribute("helper-style")
            this.$store.dispatch("Helpers/setHelper_", {id:helperId, styles:styles ? styles : ''})
           /*  this.$store.dispatch("Helpers/setHelper", helperId); */
          });
        });
      }
    },
  }
}
</script>
<style scoped lang="scss">
.custom-yellow {
  background: #fbd15e;
}
.step-title {
  font-size: 24px;
  i {    
    line-height: 32px;
    margin-right: 8px;
  }
}
</style>